import { memo, useCallback } from "react";
import { List, type ListItem } from "./List";
import { Text, View } from "@src/components";
import { StyleSheet, useUnistyles } from "react-native-unistyles";
import { Icon } from "@src/components/Icon";

type AdminsListProps = {
  items: ListItem[];
  onItemPress?: (itemId: string) => void;
};

export const AdminsList = memo(({ items, onItemPress }: AdminsListProps) => {
  const { theme } = useUnistyles();

  const renderRight = useCallback(
    () => <Icon name="chevronRight" size={theme.spacing["6xl"]} color={theme.colors.iconPrimary} />,
    [theme],
  );

  if (items.length === 0) {
    return (
      <View style={styles.emptyStateContainer}>
        <Text textStyle="sm/regular" color="textMuted" textAlign="center">
          No admins found
        </Text>
      </View>
    );
  }
  return <List items={items} onItemPress={onItemPress} renderRight={onItemPress ? renderRight : undefined} />;
});

const styles = StyleSheet.create((theme) => ({
  emptyStateContainer: {
    paddingVertical: theme.spacing["5xl"],
  },
}));
